// extracted by mini-css-extract-plugin
module.exports = {"root":"verticalNavBgImage_root__FLJiy"};